import { createLabeledMessages } from '../../../messageUtils';
const days = {
    monday: 'pondělí',
    tuesday: 'úterý',
    wednesday: 'středa',
    thursday: 'čtvrtek',
    friday: 'pátek',
    saturday: 'sobota',
    sunday: 'neděle',
    monday_short: 'po',
    tuesday_short: 'út',
    wednesday_short: 'st',
    thursday_short: 'čt',
    friday_short: 'pá',
    saturday_short: 'so',
    sunday_short: 'ne'
};
const months = {
    january: 'leden',
    february: 'únor',
    march: 'březen',
    april: 'duben',
    may: 'květen',
    june: 'červen',
    july: 'červenec',
    august: 'srpen',
    september: 'září',
    october: 'říjen',
    november: 'listopad',
    december: 'prosinec'
};
const messages = Object.assign({}, days, months);
export default Object.assign({}, messages, createLabeledMessages(messages));
